import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({component: Component, authed, location, ...rest}) => {
  console.log('Render PUBLIC | authed: ', authed, location);
  console.log(authed, authed === false);
  return (
    <Route
      {...rest}
      render={(props) => authed === false
        ? <Component {...props} />
        : <Redirect to="/" />}
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.any,
  authed: PropTypes.bool,
  location: PropTypes.any
};

export default PublicRoute;



// WEBPACK FOOTER //
// ./client/components/routes/PublicRoute.js